<template>
  <div class="Management">
      <div class="bg-black p-1 rounded">
        <!-- Header -->
        <div class="row">
          <div class="col-md-6">
            <div class="input-group flex-nowrap">
              <button class="btn btn-kraken fs-5 rounded" style="pointer-events: none; width: 15%;">
                <i class="fa-solid fa-gear" :class="{ 'fa-spin': settingAccess || processing }"></i>
              </button>
              <input class="btn bg-black text-white fw-light fs-5 rounded" style="width: 200px; cursor: default; letter-spacing: 3px;" type="text" value="Management" readonly>
              <select class="btn btn-kraken fs-5 text-white text-start rounded" style="width: 300px;" v-model="section" @change="updateSection">
                <option :value="null">Select a section...</option>
                <option value="notificators">Notificators</option>
                <option value="maps">Maps</option>
              </select>
            </div>
          </div>
          <div class="col-md-4">
            <div v-if="false" class="input-group flex-nowrap">
              <select class="btn btn-kraken fs-5 fw-light rounded w-100" v-model="section" @change="updateSection">
                <option :value="null">Select a section...</option>
                <option value="maps">Maps</option>
                <option v-if="false" value="apps">Apps</option>
                <option value="notificators">Notificators</option>
              </select>
            </div>
          </div>
          <div class="col-md-1"></div>
          <div class="col-md-3"></div>
          <div class="col-md-1">
            <button v-if="section == 'apps'" class="btn btn-suite fs-3" @click="getApps()">
              <i class="fa-solid fa-refresh"></i>
            </button>
          </div>
        </div>
      </div>
      <!-- Sections -->
      <div class="p-2 rounded mt-2" style="height: 587px;">
          <!-- Rest Area -->
          <div v-show="section==null" class="fs-3 text-white">
            <div style="margin-top: 17%;">
                <i class="fa-solid fa-xl fa-gear" :class="{'fa-spin': processing || gettingApps }"></i>
                <p class="text-white fw-light">{{actionMessage}}</p>
            </div>
          </div>
          <!-- Maps -->
          <div v-if="section == 'maps'">
            <div style="margin-top: 15%;">
                <div class="row">
                    <div class="col-md-2"></div>
                    <div class="col-md-8">
                        <p class="fw-light text-white fs-5">Map API Key</p>
                        <div class="input-group flex-nowrap">
                            <button class="btn btn-kraken fs-6 w-25 me-1">
                                <i class="fa-solid fa-xl fa-key"></i>
                            </button>
                            <input class="btn bg-dark text-info w-75 fs-6 fw-light" style="cursor: text;" v-model="maps.api_key" title="Maps API Key" placeholder="Maps API Key" type="text" :disabled="processing">
                            <button class="btn btn-kraken fs-6 w-25" @click="saveMapKey" :disabled="processing">
                                <i class="fa-solid fa-xl" :class="{'fa-save': !processing, 'fa-refresh fa-spin': processing}"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
          </div>
          <!-- Apps -->
          <div v-if="section == 'apps'">
            <div v-if="gettingApps" class="fs-3 text-white">
              <div style="margin-top: 17%;">
                  <i class="fa-solid fa-xl fa-gear fa-spin"></i>
                  <p class="text-white fw-light">Getting apps</p>
              </div>
            </div>
            <div v-if="!gettingApps" class="p-2" style="height: 580px; overflow: hidden;">
              <div class="row">
                <div class="col-md-12">
                  <!-- Header -->
                  <div class="input-group flex-nowrap">
                    <button class="btn btn-suite fs-4 me-1" style="width: 20%;">
                      <i class="fa-solid fa-xl fa-leaf"></i>
                    </button>
                    <button class="btn btn-suite fs-4 me-1" style="width: 10%;">
                      <i class="fa-solid fa-xl fa-cube"></i>
                    </button>
                    <button class="btn btn-suite fs-4 me-1" style="width: 10%;">
                      <i class="fa-solid fa-xl fa-right-to-bracket"></i>
                    </button>
                    <button class="btn btn-suite fs-4 me-1" style="width: 10%;">
                      <i class="fa-solid fa-xl fa-link"></i>
                    </button>
                    <button class="btn btn-suite fs-4" style="width: 50%;">
                      <i class="fa-solid fa-xl fa-info"></i>
                    </button>
                  </div>
                  <div class="" style="height: 480px; overflow-y: scroll;">
                    <div class="input-group flex-nowrap mt-1" v-for="(_app, appi) in apps" :key="appi">
                      <button class="btn btn-suite fs-4 me-1" style="width: 20%;">
                        {{_app.alias}}
                      </button>
                      <button :title="capitalize(_app.name)" class="btn border-suite me-1" style="width: 10%;" @click="Setapp(_app)">
                        <img :src="require(`@/assets/logos/${_app.name}_logo.png`)" width="50">
                      </button>
                      <button class="btn fs-4 me-1" :class="{'btn-suite': _app.access, 'btn-dark': !_app.access}" style="width: 10%;" @click="setAppAccess(_app)" :disabled="settingAccess">
                        <i class="fa-solid" :class="{'fa-door-open': _app.access, 'fa-door-closed': !_app.access}"></i>
                      </button>
                      <button class="btn btn-suite fs-4 me-1" style="width: 10%;" @click="hello(_app)" :disabled="_app.processing" :title="`Test connectivity to: ${_app.alias}`">
                        <i class="fa-solid fa-vial" :class="{'fa-fade': _app.processing}"></i>
                      </button>
                      <button class="btn me-1" :class="{'btn-dark': Object.keys(_app.result).length == 0, 'btn-suite': Object.keys(_app.result).length > 0}" style="width: 25%; font-size: 12px;" :disabled="_app.processing">
                        {{Object.keys(_app.result).length > 0 ? `Ping: ${_app.result.ping}`:'-'}}
                      </button>
                      <button class="btn" :class="{'btn-dark': Object.keys(_app.result).length == 0, 'btn-suite': Object.keys(_app.result).length > 0}" style="width: 25%;" :disabled="_app.processing">
                        <div v-if="Object.keys(_app.result).length > 0" class="btn text-white" style="font-size: 12px;" :class="{'btn-danger': _app.result.data != 'OK'}">
                          {{Object.keys(_app.result).length > 0 ? `Data: ${_app.result.data}`:'-'}}
                        </div>
                        <div v-if="Object.keys(_app.result).length == 0" class="text-white">
                          -
                        </div>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Notificator -->
          <div v-if="section == 'notificators'" >
              <div class="row">
                <div class="col-md-4">
                  <div class="p-2 border-top-kraken border-bottom-kraken" style="">
                    <div class="input-group flex-nowrap">
                      <div class="btn fs-5 text-white">
                        <i class="fa-solid fa-paper-plane"></i>
                      </div>
                      <input type="text" class="btn bg-black text-white fs-5" style="width: 100%; cursor: default;" value="New" readonly>
                      <div class="btn fs-5 text-white">
                        <i class="fa-solid fa-paper-plane"></i>
                      </div>
                    </div>
                    <div class="input-group flex-nowrap w-100 mt-2">
                      <select v-model="notificator.type" class="btn btn-kraken fs-6 w-100" @change="setNotificator">
                        <option :value="null">Select type...</option>
                        <option value="ms_teams">Microsoft Teams</option>
                        <option value="snmp_trap">SNMP Trap</option>
                        <option value="e_mail">E-Mail</option>
                      </select>
                      
                    </div>
                    <div :class="{'disabled-div': addingNotificator || deletingNotificator}">
                      <div class="input-group flex-nowrap w-100 mt-2">
                        <input type="text" class="btn bg-input border-bottom-kraken w-100 fs-6 text-white" placeholder="Name" v-model="notificator.name" style="cursor: text;">
                      </div>
                      <div class="input-group flex-nowrap w-100 mt-2">
                        <input type="text" class="btn bg-input border-bottom-kraken w-100 fs-6 text-white" placeholder="Alias" v-model="notificator.alias" style="cursor: text;">
                      </div>
                      <div class="input-group flex-nowrap w-100 mt-2 mb-2">
                        <input type="text" class="btn bg-input border-bottom-kraken w-100 fs-6 text-white" placeholder="Destination" v-model="notificator.destination" style="cursor: text;">
                      </div>
                      <!-- MS Teams -->
                      <div v-if="notificator.type=='ms_teams'" class="input-group flex-nowrap w-100 mt-2"></div>
                      <!-- SNMP Trap -->
                      <div v-if="notificator.type=='snmp_trap'" class="input-group flex-nowrap w-100 mt-2 mb-2">
                        <input type="text" class="btn bg-input border-bottom-kraken w-100 fs-6 text-white" placeholder="SNMP Community" v-model="notificator.data.community" style="cursor: text;">
                      </div>
                      <!-- E-Mail -->
                      <div v-if="notificator.type=='e_mail'" >
                        <div class="input-group flex-nowrap w-100 mt-2 mb-2">
                          <button class="btn btn-kraken w-25 fs-6">
                            CC
                          </button>
                          <textarea class="btn bg-input border-bottom-kraken w-100 fs-6 text-white" id="cc_mail" style="cursor: text; height: 100px;" placeholder="CC" v-model="notificator.data.cc"></textarea>
                        </div>
                      </div>
                      <button class="btn btn-kraken fs-5 w-100" @click="addNotificator" :disabled="addingNotificator || deletingNotificator || notificator.type == null">
                        <i class="fa-solid fa-save" :class="{'fa-beat-fade': addingNotificator}"></i>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="col-md-8">
                  <div class="p-2">
                    <div class="input-group flex-nowrap">
                      <input type="text" class="btn bg-black text-white text-start fs-5" style="width: 85%; cursor: default;" value="My Notificators" readonly>
                      <button class="btn btn-kraken rounded fs-5" style="width: 15%;" @click="getNotificators" :disabled="gettingNotificators">
                        <i class="fa-solid fa-refresh" :class="{'fa-spin': gettingNotificators}"></i>
                      </button>
                    </div>
                    <div class="input-group flex-nowrap mt-2" style="overflow-y: scroll; pointer-events: none;">
                      <input v-if="toggle_name_alias" type="text" class="btn btn-kraken me-1" value="Name" @click="toggle_name_alias = !toggle_name_alias" style="width: 30%;" readonly>
                      <input v-if="!toggle_name_alias" type="text" class="btn btn-kraken me-1" value="Alias" @click="toggle_name_alias = !toggle_name_alias" style="width: 30%;" readonly>
                      <input type="text" class="btn btn-kraken me-1" value="Type" style="width: 20%;" readonly>
                      <input type="text" class="btn btn-kraken me-1" value="Destination" style="width: 40%;" readonly>
                      <input type="text" class="btn btn-kraken" value="" style="width: 10%;" readonly>
                    </div>
                    <div class="mt-1" style="overflow-y: scroll;" :class="{'disabled-div': deletingNotificator}">
                      <div class="input-group flex-nowrap mt-1" v-for="(d,i) in notificators" :key="i">
                        <input v-if="toggle_name_alias" type="text" class="btn text-white border-bottom-kraken me-1" :value="d.name" style="width: 30%; cursor: default; pointer-events: none;" readonly>
                        <input v-if="!toggle_name_alias" type="text" class="btn text-white border-bottom-kraken me-1" :value="d.alias" style="width: 30%; cursor: default; pointer-events: none;" readonly>
                        <input type="text" class="btn border-bottom-kraken text-white me-1" style="width: 20%; cursor: default; pointer-events: none;" :value="translator[d.type]" readonly>
                        <input type="text" class="btn border-bottom-kraken text-white me-1" style="width: 40%; cursor: default; pointer-events: none;" :value="d.destination" readonly>
                        <button class="btn btn-danger" style="width: 10%;" @click="deleteNotificator(d)">
                          <i class="fa-solid fa-trash"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
          </div>
      </div>
  </div>
</template>

<script>
// Import the component with the line below.
//import Base from '@/components/Base.vue'

import axios from "axios";

export default {
  name: 'Management',
  components: {},
  data(){
    return {
      // General
      appclient: null,
      site: null,
      stage: null,
      section: null,
      processing: false,
      // Maps
      maps: {
        api_key: null
      },

      // Apps
      gettingApps: false,
      apps: [],
      settingAccess: false,

      // Notificator
      addingNotificator: false,
      deletingNotificator: false,
      notificator:{
        name: null,
        alias: null,
        type: null,
        destination: null,
        data: null
      },
      def_notificator:{
        name: null,
        alias: null,
        type: null,
        destination: null,
        data: null
      },
      gettingNotificators: false,
      notificators: [],
      translator:{
        ms_teams: 'Microsoft Teams',
        snmp_trap: 'SNMP Trap',
        e_mail: 'E-Mail'
      },
      toggle_name_alias: false,

      // Message
      action: "default",
      actionMessage: "Select a section."

    }
  },
  methods:{
    // Update Section
    updateSection(){
      // Apps
      if (this.section == 'apps'){
        this.getApps()
      }
    },
    // Apps
    getApps(){
      this.gettingApps = true
      const params = {}
      const dest = this.site+ '/suite/management/getApps'
      axios
          .get(dest, {params})
          .then(rx => {
              this.apps = rx.data.apps
              this.gettingApps = false
              this.section = 'apps'
          })
          .catch(error => {
              this.processErrorMessage(error)
              this.gettingApps = false
          });
    },
    setAppAccess(_app){
      this.settingAccess = true
      const params = { uid: _app.uid, access: !_app.access }
      const dest = this.site+ '/suite/management/setAppAccess'
      var idx = this.apps.indexOf(_app)
      axios
          .post(dest, {params})
          .then(rx => {
              this.settingAccess = false
              this.apps[idx].access = !_app.access
          })
          .catch(error => {
              this.processErrorMessage(error)
              this.settingAccess = false
          });
    },
    hello(_app){
      var idx = this.apps.indexOf(_app)
      this.apps[idx].processing = true
      this.apps[idx].result = {}
      const params = { app: _app.name}
      const dest = this.site + '/suite/main/hello'
      axios
          .get(dest, {params})
          .then(rx => {
            this.apps[idx].processing = false
            this.apps[idx].result = rx.data
          })
          .catch(error => {
              alert(error.response.data.error)
              this.apps[idx].processing = false
          });
    },

    // Maps
    getMapKey(){
        const params = {}
        const dest = this.site + '/suite/management/getMapKey'
        axios
            .get(dest, {params})
            .then(rx => {
                this.maps.api_key = rx.data.key
            })
            .catch(error => {
                this.processErrorMessage(error)
            });
    },
    saveMapKey(){
        this.processing = true
        const params = { map_key: this.maps.api_key }
        const dest = this.site + '/suite/management/setMapKey'
        axios
            .post(dest, {params})
            .then(rx => {
                alert(rx.data.message)
                this.processing = false
            })
            .catch(error => {
                this.processErrorMessage(error)
                this.processing = false
            });
    },

    // Notificator
    setNotificator(){
      if (this.notificator.type == 'ms_teams'){
        this.notificator.data = { data: false }
      }
      else if (this.notificator.type == 'snmp_trap'){
        this.notificator.data = { community: null }
      }
      else if (this.notificator.type == 'e_mail'){
        this.notificator.data = { cc: '' }
      }
    },
    getNotificators(){
      this.gettingNotificators = true
      const params = {}
      const dest = this.site + '/suite/management/getNotificators'
      axios
          .get(dest, {params})
          .then(rx => {
              this.notificators = rx.data.notificators
              this.gettingNotificators = false
          })
          .catch(error => {
              this.processErrorMessage(error)
              this.gettingNotificators = false
          });
    },
    addNotificator(){
      this.addingNotificator = true
      const dest = this.site + '/suite/management/addNotificator'
      axios
          .post(dest, this.notificator)
          .then(rx => {
              alert(rx.data.message)
              this.addingNotificator = false
              this.getNotificators()
              this.notificator = this.cloneObject(this.def_notificator)
          })
          .catch(error => {
              this.processErrorMessage(error)
              this.addingNotificator = false
          });
    },
    deleteNotificator(_notificator){
      this.deletingNotificator = true
      const params = { uid: _notificator.uid }
      const dest = this.site + '/suite/management/deleteNotificator'
      axios
          .post(dest, params)
          .then(rx => {
              alert(rx.data.message)
              const idx = this.notificators.indexOf(_notificator)
              this.notificators.splice(idx, 1)
              this.deletingNotificator = false
          })
          .catch(error => {
              this.processErrorMessage(error)
              this.deletingNotificator = false
          });
    },
    

    


    // Errors
    processErrorMessage(error, mode="alert"){
        var err_message = null
        try {
            err_message = error.response.data.data.errorMessage
        } 
        catch (nerror) {
            try { 
                err_message = error.response.data.errorMessage
            } 
            catch (error) { 
                console.log(error) 
            }
        }
        if (mode == "alert"){ alert(err_message)  }
        else if (mode == "console"){ console.log(err_message)  }
    return err_message
    },

    // -- Miscellaneous
    capitalize(_string){
        if (_string == null){return ""}
        const lower = String(_string).toLowerCase()
        return String(_string).charAt(0).toUpperCase() + lower.slice(1)
    },
    cloneObject(_object){
      return JSON.parse(JSON.stringify(_object))
    },
    getCookie(name){
      const cookies = document.cookie.split(';');
      for (let cookie of cookies) {
            cookie = cookie.trim();
            if (cookie.startsWith(name + '=')) {
              return cookie.substring(name.length + 1);
            }
      }
      return null;
    }
  },
  created: function(){
    //this.appclient = localStorage.getItem('vrfaware_client')
    //this.site = this.appServiceUrl.replace('_CLIENT_NAME_', this.appclient)
    this.stage = process.env.NODE_ENV
    if (this.stage == 'development'){
      this.site = process.env.VUE_APP_SERVICE_URL
    }
    else{
      this.site = `${window.location.protocol}//${window.location.host}/kraken`
    }
    axios.defaults.headers.common['X-CSRFToken'] = this.getCookie('csrf_prt')
    this.getMapKey()
    this.getNotificators()
  }
}
</script>

<style scoped>

  .border-suite{
    border-top: solid 2px rgb(0, 48, 90);
    border-bottom: solid 2px rgb(0, 48, 90);
    border-left: solid 2px rgb(0, 48, 90);
    border-right: solid 2px rgb(0, 48, 90);
  }

  .border-bottom-suite{
    border-bottom: solid 2px rgb(0, 48, 90);
  }

  .bg-suite{
    color: White;
    background-color: rgb(0, 48, 90);
    text-shadow: 3px 5px 4px Black;
  }

  .btn-suite{
    color: White;
    background-color: rgb(0, 48, 90);
    transition-duration: 0.5s;
    text-shadow: 3px 5px 4px Black;
    border-left: solid 6px transparent;
    border-right: solid 6px transparent;
  }
  .btn-suite:hover{
    color: rgb(0, 179, 255);
    background-color: rgb(1, 77, 144);
  }
  
  .app-icon-active{
    border-left: solid 5px rgb(64, 133, 88);
    border-right: solid 5px rgb(64, 133, 88);
    transition-duration: 0.5s;
    opacity: 1.0;
  }
  .app-icon-active:hover{
    opacity: 0.7;
  }
  .app-icon-inactive{
    border-left: solid 5px rgb(117, 0, 0);
    border-right: solid 5px rgb(117, 0, 0);
    transition-duration: 0.5s;
    opacity: 1.0;
  }
  .app-icon-inactive:hover{
    opacity: 0.7;
  }

  .disabled-div{
    pointer-events: none;
    opacity: 0.5;
  }


  .bg-input{
      background-color: rgb(7,13,15);
      color: white;
  }
  .temporal-disable{
      opacity: 0.5;
      pointer-events: none;
  }
  .btn-kraken{
      background-color: rgb(20, 63, 162);
      color: white;
      transition-duration: 0.5s;
      text-shadow: 3px 5px 4px Black;
      border-left: solid 3px transparent;
      border-right: solid 3px transparent;
  }
  .btn-kraken:hover{
      background-color: rgb(0, 17, 39);
      color: rgb(0, 211, 249);
  }
  .bg-kraken{
      background-color: rgb(20, 63, 162);
      color: white;
      transition-duration: 0.5s;
      text-shadow: 3px 5px 4px Black;
      border-left: solid 3px transparent;
      border-right: solid 3px transparent;
  }
  .border-bottom-kraken{
    border-bottom: solid 1px rgb(20, 63, 162);
  }
  .border-top-kraken{
    border-top: solid 1px rgb(20, 63, 162);
  }


  /* Scrollbar */
  /* width */
  ::-webkit-scrollbar {
      width: 10px;
      height: 7px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
      box-shadow: inset 0 0 5px rgb(37, 33, 33); 
      border-radius: 10px;
  }
  
  /* Handle */
  ::-webkit-scrollbar-thumb {
      background: rgb(168, 245, 0); 
      border-radius: 10px;
      transition-duration: 2.0s;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
      background: rgb(208, 240, 1); 
  }

</style>
